<template>

  <div class="-wrapper v-h-center- -height-100 dashboard-graph-2">
      <div class="graph-mini">
          <div class="graph-y">
              <span class="y-name" v-for="value in valueList" :key="value">{{value}}</span>
          </div>
          <div class="graph-cont">
              <div class="graph-item gray -button-ui" :style="{height: prevMonthHeight}" :title="prevMonthTitle" @click="onClickChart(chartData[0])">
                  <span class="name">전전월</span>
              </div>
              <div class="graph-item blue -button-ui" :style="{height: currentMonthHeight}" :title="currentMonthTitle" @click="onClickChart(chartData[1])">
                  <span class="name">전월</span>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { numberWithCommas } from 'ops2clientlibrary/src/library/regexp'

const UNIT_KMB = {
  K: 1e+3,
  M: 1e+6,
  B: 1e+9
}

export default {
  name: 'total-cost-prev-month-am-chart',
  props: {
    chartData: {
      type: Array,
      default: () => ([]),

    },
    bigNumberPrefixes: {
      type: Array,
      default: () => ([
        { "number": 1e+3, "suffix": "천" },
        { "number": 1e+4, "suffix": "만" },
        { "number": 1e+8, "suffix": "억" }
      ])
    }
  },
  computed: {
    prevMonthHeight () {
      if(this.prevMonth === 0 ){
        return '0%'
      }
      const {labelMaxVal, prefix} = this.labelMaxVal
      const percent = (this.prevMonth / (labelMaxVal * prefix.number) * 100).toFixed(3) + '%'
      return percent
    },
    currentMonthHeight () {
      if(this.currentMonth === 0 ){
        return '0%'
      }
      const {labelMaxVal, prefix} = this.labelMaxVal
      const percent = (this.currentMonth / (labelMaxVal * prefix.number) * 100).toFixed(3) + '%'
      return percent
    },
    prevMonthTitle () {
      return '￦' + numberWithCommas(this.prevMonth)
    },
    currentMonthTitle () {
      return '￦' + numberWithCommas(this.currentMonth)
    },
    valueList () {
      const {labelMaxVal, suffix} = this.labelMaxVal
      const labelMiddleVal = (labelMaxVal / 2).toFixed(0)
      const valueList = [labelMaxVal, labelMiddleVal].filter(item => !isNaN(item)).map(item => `${item}${suffix}`)
      valueList.push(0)
      return valueList
    },
    labelMaxVal () {
      const maxVal = Math.max(this.prevMonth, this.currentMonth)
      const prefix = this.getPrefix(maxVal)
      const suffix = prefix.suffix
      const labelMaxVal = (maxVal / prefix.number + 1).toFixed(0) || 0
      return {labelMaxVal, suffix, prefix}
    }
  },
  data () {
    return {
      prevMonth: 0,
      currentMonth: 0
    }
  },
  methods: {
    getPrefix (val) {
      const prefixList = [{number: 0, suffix: ''}, ...this.bigNumberPrefixes]
      let result = prefixList[0]
      for (let prefix of prefixList) {
        if (val > prefix.number) {
          result = prefix
        }
      }
      return result
    },
    onClickChart (data) {
      this.$emit('click', data)
    }
  },
  watch: {
    chartData: {
      handler () {
        if (this.chartData.length > 0) {
          const category1 = this.chartData[0].category
          const category2 = this.chartData[1].category
          this.prevMonth = Number(this.chartData[0][category1])
          this.currentMonth = Number(this.chartData[1][category2])
        }
      },
      immediate: true,
      deep: true
    },
  }
}
</script>
<style scoped>
  .graph-mini {position:relative; display:flex; width:100%; height:100%; margin-left:26px; padding:0 16px; border-bottom:1px solid #e2e6eb; align-items: flex-end}
  .graph-mini .graph-y {position:absolute; left:-31px; top:0; display:flex; flex-direction:column; justify-content:space-between; width:41px; height:100%; border-right:1px solid #e2e6eb; }
  .graph-mini .graph-y .y-name {display:block; color:#7e8793; font-size:12px; line-height:14px; text-align:right; padding-right:4px;}
  .graph-mini .graph-cont {display:flex; height:calc(100% - 7px); align-items:flex-end;}
  .graph-mini .graph-cont .graph-item {position:relative; display:flex; flex:0 0 32px; width:32px;}
  .graph-mini .graph-cont .graph-item .name {position:absolute; left:0; bottom:-20px; width:100%; height:20px; line-height:20px; color:#7e8793; font-size:12px; text-align:center;}
  .graph-mini .graph-cont .graph-item + .graph-item {margin-left:16px;}
  .graph-mini .graph-cont .graph-item.gray {background:#b0b6bd;}
  .graph-mini .graph-cont .graph-item.blue {background:#086ce8;}

  .dashboard-graph-1 {flex:1;}
  .dashboard-graph-2 {flex-shrink:0;}

  @media screen and (max-width: 1250px) {
    .graph-mini { display: none; }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/components/TotalCostPrevMonthAmChart.vue